import './locations.scss';
import { global_hooks } from 'src/globals';
import Dropdown from 'components/ui/dropdown/Dropdown';

global_hooks.on('init', () => {
	const select = document.getElementById('locations_select');
	const panel  = document.getElementById('locations_panel');

	if (!select) return;

	const dropdown = new Dropdown(select, { raw: true });

	dropdown.hooks.on('select', (option) => {
		const loc = locations_data?.locations?.[option.value];
		if (!loc || !panel) return;

		const phone   = panel.querySelector('.js_phone');
		const address = panel.querySelector('.js_address');
		const hours   = panel.querySelector('.js_hours');
		const link    = panel.querySelector('.js_link');
		const map     = panel.querySelector('.js_map');

		if (phone)   { phone.textContent = loc.phone;   phone.href = 'tel:' + loc.phone; }
		if (address) { address.innerHTML = loc.suburb; }
		if (hours)   { hours.innerHTML = loc.opening_hours; }
		if (link)    { link.href = loc.link; }
		if (map && loc.map_embed) { map.innerHTML = loc.map_embed; }
	});
});
